import React from 'react';

type CaretDirection = 'up' | 'down' | 'left' | 'right';

interface TriangleCaretProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
    direction?: CaretDirection;
}

const getRotation = (direction: CaretDirection): string => {
    switch (direction) {
        case 'down':
            return 'rotate(180deg)';
        case 'left':
            return 'rotate(-90deg)';
        case 'right':
            return 'rotate(90deg)';
        case 'up':
        default:
            return 'rotate(0deg)';
    }
};

export default function TriangleCaret({ color, direction = 'down', ...restProps }: TriangleCaretProps) {
    const rotation = getRotation(direction);

    return (
        <svg
            width="7"
            height="4"
            viewBox="0 0 7 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: rotation, display: 'block', margin: 'auto' }}
            {...restProps}
        >
            <path
                d="M0.00955904 3.40274C-0.00968731 3.49975 0.000268724 3.60029 0.0381678 3.69164C0.0759933 3.78301 0.140064 3.86111 0.222277 3.91607C0.30449 3.97103 0.401153 4.00037 0.500043 4.00039H6.50004C6.59899 4.00047 6.69574 3.97119 6.77803 3.91625C6.86033 3.86132 6.92448 3.7832 6.96235 3.69179C7.00023 3.60038 7.01013 3.49978 6.99081 3.40274C6.97148 3.3057 6.9238 3.21657 6.85379 3.14664L3.85379 0.146643C3.80736 0.100155 3.75221 0.0632755 3.69151 0.0381134C3.63081 0.0129512 3.56575 0 3.50004 0C3.43433 0 3.36927 0.0129512 3.30857 0.0381134C3.24787 0.0632755 3.19273 0.100155 3.14629 0.146643L0.146293 3.14664C0.0763893 3.21661 0.0288054 3.30573 0.00955904 3.40274Z"
                fill={color || '#21201C'}
            />
        </svg>
    );
}
